<template>
  <AtroContent col class="flex-1 bg-white">
    <slot />
  </AtroContent>
</template>
